import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch,
} from 'react-router-dom';

import './less/App.less';

import SignUp from './scenes/SignUp';
import Login from './scenes/Login';
import ForgotPassword from './scenes/ForgotPassword';
import UpdatePassword from './scenes/UpdatePassword';
import TwoFactorCode from './scenes/TwoFactorCode';

import LanguageProvider from './translations/LanguageProvider';
import UserDataProvider from './EeckmanClientInfo/UserDataProvider';

const App = () => (
    <Router>
        <LanguageProvider>
            <div className="App">
                <Switch>
                    <Route
                        path="/sign-up"
                        component={() => (
                            <UserDataProvider>
                                <SignUp />
                            </UserDataProvider>
                        )}
                    />
                    <Route
                        exact
                        path="/login"
                        component={Login}
                    />
                    <Route
                        exact
                        path="/forgot-password"
                        component={ForgotPassword}
                    />
                    <Route
                        exact
                        path="/password/update/:changePasswordId"
                        component={UpdatePassword}
                    />
                    <Route
                        exact
                        path="/twoFactor"
                        component={TwoFactorCode}
                    />
                    <Redirect
                        exact
                        from="/"
                        to="/login"
                    />
                </Switch>
            </div>
        </LanguageProvider>
    </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js